import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@workspace/web-ui/components/select"
import { paymentStatusOptions } from "../../libs/filters"

interface PaymentStatusFiltersProps {
    status: string
    setStatus: React.Dispatch<React.SetStateAction<string>>
}

export const PaymentStatusFilters = ({ status, setStatus }: PaymentStatusFiltersProps) => {
    const handleStatusChange = (value: string) => {
        setStatus(value)
    }

    return (
        <Select value={status} onValueChange={handleStatusChange}>
            <SelectTrigger className="w-fit button-primary !px-4 !py-3">
                <SelectValue placeholder="Status" />
            </SelectTrigger>
            <SelectContent>
                {paymentStatusOptions.map((statusItem) => (
                    <SelectItem 
                        key={statusItem.value} 
                        value={statusItem.value}
                    >
                        {statusItem.label}
                    </SelectItem>
                ))}
            </SelectContent>
        </Select>
    )
} 